<template>
  <modal
    name="contact-form"
    :minHeight="1000"
    :width='auto'
    :height='auto'
    :adaptive="true"
    :scrollable="true"
  >
    <div
      class="col-12 mx-3"
      style="background-image: linear-gradient(270deg, #fdfdfd 73%, #c0d459 51%); height: 90px;"
    >
      <h3 style="line-height: 90px; font-size: 30px; color: black; text-align: left; padding-left: 40px;">
        NAPISZ DO NAS
      </h3>
      <div style="position:absolute; right:10px;top:10px; cursor:pointer;" @click="closeModal()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
</svg></div>
    </div>
    
    <p class="mt-5">
      Wypełnij formularz kontaktowy by dowiedzieć się więcej o lokalu {{ flat }}
    </p>

    <!-- <p> Lokal: {{ flat }}</p> -->
    <form class="mb-5">
      <div class="form-group px-3 py-2 col-12">
        <label class="d-flex text-left"
          >Imię i nazwisko
          <p style="color: red">*</p></label
        >
        <input class="col-12" type="text" v-model="formData.contact_name"/>
        <span style="color:red;" v-if="nameError">{{ nameError }}</span>
      </div>
      <div class="form-group px-3 py-2 col-12">
        <label class="d-flex text-left"
          >Email
          <p style="color: red">*</p></label
        >
        <input class="col-12" type="text" v-model="formData.contact_email" />
        <span style="color:red;" v-if="emailError">{{ emailError }}</span>
      </div>
      <div class="form-group px-3 py-2 col-12">
        <label class="d-flex text-left"
          >Telefon
          <p style="color: red">*</p></label
        >
        <input class="col-12" type="text" v-model="formData.contact_phone" />
        <span style="color:red;" v-if="phoneError">{{ phoneError }}</span>
      </div>

      <div class="form-group col-12 py-2 px-3">
        <label class="d-flex text-left">Wiadomość</label>
        <textarea class="col-12" v-model="formData.contact_message" />
      </div>
      <div class="form-check col-10 mx-auto p-1">
        <input class="form-check-input" type="checkbox" id="zgoda1"  v-model="formData.contact_acceptance1" />
        <label class="form-check-label" for="zgoda1"
          >Wyrażam zgodę na otrzymywanie informacji handlowych od Developme sp.
          z o.o. drogą elektroniczną na wskazany w formularzu numer telefonu
          oraz adres poczty elektronicznej.</label
        >
      </div>
      <div class="form-check col-10 mx-auto p-1">
        <input class="form-check-input" type="checkbox" id="zgoda2" v-model="formData.contact_acceptance2" />
        <label class="form-check-label" for="zgoda2"
          >Wyrażam zgodę na marketing bezpośredni Developme sp. z o.o. przy
          użyciu telekomunikacyjnych urządzeń końcowych i automatycznych
          systemów wywołujących.</label
        >
      </div>
      <div class="form-check col-10 mx-auto p-1">
        <input class="form-check-input" type="checkbox" id="zgoda3"  v-model="formData.contact_acceptance3" />
        <label class="form-check-label" for="zgoda3"
          >Akceptuję treść <a href="https://www.willa-wroclaw.pl/polityka-prywatnosci/" target="_blank">Polityki Prywatności</a> Administratorem danych osobowych
          jest DevelopMe sp. z o.o. Dane osobowe będą przetwarzane w celu
          wskazanym w treści wyrażonej zgody, w celu realizacji zamówionego
          kontaktu, marketingu bezpośredniego własnych produktów i usług oraz
          obrony przed ewentualnymi roszczeniami oraz w celu wykonania
          obowiązków wynikających z przepisów prawa. Przysługuje Pani/Panu prawo
          do dostępu do danych, ich usunięcia, ograniczenia przetwarzania,
          przenoszenia, sprzeciwu, sprostowania oraz cofnięcia zgód w każdym
          czasie.</label
        >
      </div>
      
        <input style="display:none;" type="text" v-model="formData.contact_flat" />
    
      <button class="btn btn-info btn-lg m-5" type="button" @click="submitForm()">Wyślij</button>
    </form>
  </modal>
</template>
<script>
import axios from "axios";
export default {
  props: ["flat"],
  
  data() {
    return {
      
      contactForm: {
        email: "kamil.glabek@gmail.com",
        textarea: "testowa wiadomość",
      },
      holder:"",
      // url: "http://test.2qbs.pl/wp-json/contact-form-7/v1/contact-forms/200/feedback",
      formData: {
        contact_name: "",
        contact_email: "",
        contact_phone: "",
        contact_message: "",
        contact_flat:"",
        contact_acceptance1:"",
        contact_acceptance2:"",
        contact_acceptance3:""
        // contact_pageName:"Nova Rokokowa",
        // contact_pageEmail:"wordpress@novarokokowa.pl"
      },
      nameError:"",
      emailError:"",
      phoneError:""
      
    };
  },
  updated(){
    this.formData.contact_message = "Proszę o więcej informacji na temat lokalu " + this.flat
    this.formData.contact_flat = this.flat;
   
    
  },
 
  methods: {
   
    test(){
      console.log(this.flat)
    },
    closeModal(){
      this.$modal.hide("contact-form")
      
    },
    checkForm(){
      if(!this.formData.contact_name) {
        this.nameError = "Pole jest obowiązkowe"
        return false
      } 

      if(!this.formData.contact_email) {
        this.emailError = "Pole jest obowiązkowe"
        return false
      } 

      if(!this.formData.contact_phone) {
        this.phoneError = "Pole jest obowiązkowe"
        return false
      } 

    },
    submitForm() {
     
      if(this.checkForm() != false){
      axios
        .post(`https://willa-wroclaw.pl/wp-json/contact/v1/send`, this.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.success = true;
          console.log(res);
          this.$fire({
  text: "Twoja wiadomość została wysłana.",
  type: "success",
  timer: 3000
}).then(()=> {
            this.$modal.hide("contact-form")
              this.formData.contact_message="",
              this.formData.contact_flat="",
              this.formData.contact_acceptance1="",
              this.formData.contact_acceptance2="",
              this.formData.contact_acceptance3=""
          });
          
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error(err.response);
        });
    }
  },
    
  },
};
</script>

<style>
input,
textarea {
  background-color: #ffffff;
  border-color: #e1e1e1;
  border-width: 0px 0px 1px 0px;
  border-radius: 0px 0px 0px 0px;
}
input,
textarea:focus {
  outline: none;
  border: 1px solid #e1e1e1;
  border-radius: 1px;
}
.form-check-label {
  font-size: 12px;
  text-align: left;
}
.vm--modal {
  height: auto !important;
}
.vm--container {
  overflow: auto;
}
</style>